var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqBtaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.72,
    cy: 20,
    rx: 19.72,
    ry: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4674_77297)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2026 15.125C12.59 15.125 12.1602 15.6443 12.1602 16.1992C12.1602 16.7541 12.59 17.2734 13.2026 17.2734C13.8153 17.2734 14.2451 16.7541 14.2451 16.1992C14.2451 15.6443 13.8153 15.125 13.2026 15.125Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5034 19.6641C22.8908 19.6641 22.4609 20.1834 22.4609 20.7383C22.4609 21.2932 22.8908 21.8125 23.5034 21.8125C24.116 21.8125 24.5459 21.2932 24.5459 20.7383C24.5459 20.1834 24.116 19.6641 23.5034 19.6641Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73633 14.0313C9.73633 13.2028 10.3985 12.5312 11.2153 12.5312H25.492C26.3088 12.5312 26.971 13.2028 26.971 14.0312V22.9062C26.971 23.7346 26.3088 24.4062 25.492 24.4062H11.2153C10.3985 24.4062 9.73633 23.7346 9.73633 22.9062V14.0313ZM11.2153 14.0313V22.9062L25.492 22.9062L25.492 14.0312L11.2153 14.0313Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1914 18.4687C15.1914 16.6604 16.5709 15.125 18.3549 15.125C20.1388 15.125 21.5183 16.6604 21.5183 18.4687C21.5183 20.277 20.1388 21.8125 18.3549 21.8125C16.5709 21.8125 15.1914 20.277 15.1914 18.4687ZM18.3549 16.625C17.4614 16.625 16.6704 17.4121 16.6704 18.4687C16.6704 19.5254 17.4614 20.3125 18.3549 20.3125C19.2483 20.3125 20.0393 19.5254 20.0393 18.4687C20.0393 17.4121 19.2483 16.625 18.3549 16.625Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6543 16.4219C29.0627 16.4219 29.3938 16.7577 29.3938 17.1719V24.9531C29.3938 26.0452 28.5569 27 27.4423 27H14.1106C13.7022 27 13.3711 26.6642 13.3711 26.25C13.3711 25.8357 13.7022 25.5 14.1106 25.5H27.4423C27.6664 25.5 27.9148 25.2935 27.9148 24.9531V17.1719C27.9148 16.7577 28.2459 16.4219 28.6543 16.4219Z",
    fill: "#E60000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4674_77297"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.85938,
    y: 10,
    width: 19.72,
    height: 20,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBtaIcon);
export default __webpack_public_path__ + "static/media/FaqBtaIcon.156800c195bbd3fc839f4a6a204f43e3.svg";
export { ForwardRef as ReactComponent };